import * as urlUtils from '@arcgis/core/core/urlUtils'
import esriConfig from '@arcgis/core/config'
import store from '../store'
import { spEsri } from '../globals'

export default (token, configJson) => {
  const serviceUrlsThatSkipProxy = configJson.appConfig?.noProxyUrls ? configJson.appConfig.noProxyUrls : []

  let serviceUrlsThatGoThroughProxy = addUrlsToProxy(configJson)
  serviceUrlsThatGoThroughProxy = serviceUrlsThatGoThroughProxy.filter(serviceUrl => !serviceUrlsThatSkipProxy.includes(serviceUrl))

  if (configJson.widgetConfig?.print?.config) {
    serviceUrlsThatGoThroughProxy.push(configJson.widgetConfig.print.config.url.substring(0, configJson.widgetConfig.print.config.url.lastIndexOf('/')))
  }
  const proxyUrl = process.env.VUE_APP_PROXY_URL.startsWith('http://') || process.env.VUE_APP_PROXY_URL.startsWith('https://') ? process.env.VUE_APP_PROXY_URL : window.origin + process.env.VUE_APP_PROXY_URL
  esriConfig.request.interceptors = []
  for (const service of serviceUrlsThatGoThroughProxy) {
    if (service.customProxy) {
      urlUtils.addProxyRule({
        urlPrefix: service.url,
        proxyUrl: service.customProxy,
      })
    } else {
      urlUtils.addProxyRule({
        urlPrefix: service,
        proxyUrl: proxyUrl,
      })
    }
    esriConfig.request.interceptors.push({
      urls: service.url ? service.url : service,
      before: function (params) {
        params.requestOptions.headers = params.requestOptions.headers || {}
        if (spEsri.lastAdvancedEditOperation) {
          params.requestOptions.headers['gdi-advanced-edit-operation'] = spEsri.lastAdvancedEditOperation
          spEsri.lastAdvancedEditOperation = null
        }
        if (['wms', 'WMS'].indexOf(params.requestOptions.query.service) > -1 || ['wms', 'WMS'].indexOf(params.requestOptions.query.SERVICE) > -1) {
          params.requestOptions.headers['is-wms'] = true
        }
        params.requestOptions.headers.authorization = 'Bearer ' + token
        params.requestOptions.headers.name = store.getters.getViewerName
      },
    })
  }
}

function addUrlsToProxy (configJson) {
  const urlsToProxy = []
  if (configJson.operationalMaps) {
    urlsToProxy.push(addServiceUrlsToProxy(configJson.operationalMaps))
  }
  if (configJson.widgetConfig?.editor?.services) {
    urlsToProxy.push(addEditorServiceUrlsToProxy(configJson.widgetConfig.editor.services))
  }
  if (configJson.customRelations?.externalArcGISRestRelations) {
    urlsToProxy.push(addCustomRelationsUrlsToProxy(configJson.customRelations.externalArcGISRestRelations))
  }
  urlsToProxy.push(addGeometryServiceUrlsToProxy(configJson))
  urlsToProxy.push(addAlternateFindTasksUrlsToProxy(configJson))

  return urlsToProxy.flat()
}

function addServiceUrlsToProxy (services) {
  const urlsToProxy = []
  for (const service of services) {
    if (service.customProxy) {
      if (service.mapURL.includes('/SceneServer')) {
        urlsToProxy.push({ url: service.mapURL.split('/SceneServer')[0], customProxy: service.customProxy })
      } else if (service.mapURL.includes('/FeatureServer')) {
        urlsToProxy.push({ url: service.mapURL.split('/FeatureServer')[0], customProxy: service.customProxy })
      } else if (service.mapURL.includes('/MapServer')) {
        urlsToProxy.push({ url: service.mapURL.split('/MapServer')[0], customProxy: service.customProxy })
      } else if (service.mapURL.includes('/ImageServer')) {
        urlsToProxy.push({ url: service.mapURL.split('/ImageServer')[0], customProxy: service.customProxy })
      } else if (service.mapURL.includes('/wms')) {
        urlsToProxy.push({ url: service.mapURL.split('/wms')[0], customProxy: service.customProxy })
      } else if (service.mapURL.includes('/service.svc')) {
        urlsToProxy.push({ url: service.mapURL.split('/service.svc')[0], customProxy: service.customProxy })
      }
    } else if (service.mapURL.includes('/SceneServer')) {
      urlsToProxy.push(service.mapURL.split('/SceneServer')[0])
    } else if (service.mapURL.includes('/FeatureServer')) {
      urlsToProxy.push(service.mapURL.split('/FeatureServer')[0])
    } else if (service.mapURL.includes('/MapServer')) {
      urlsToProxy.push(service.mapURL.split('/MapServer')[0])
    } else if (service.mapURL.includes('/ImageServer')) {
      urlsToProxy.push(service.mapURL.split('/ImageServer')[0])
    } else if (service.mapURL.includes('/wms')) {
      urlsToProxy.push(service.mapURL.split('/wms')[0])
    } else if (service.mapURL.includes('/service.svc')) {
      urlsToProxy.push(service.mapURL.split('/service.svc')[0])
    }
  }
  return urlsToProxy
}
function addEditorServiceUrlsToProxy (services) {
  const urlsToProxy = []
  for (const service of Object.values(services)) {
    urlsToProxy.push(service.featureServiceUrl.split('/FeatureServer')[0])
  }

  return urlsToProxy
}
function addCustomRelationsUrlsToProxy (externalRelations) {
  const urlsToProxy = []
  for (const parentUrl in externalRelations) {
    const externals = externalRelations[parentUrl]
    for (const external of externals) {
      urlsToProxy.push(external.childLayerUrl)
    }
  }
  return urlsToProxy
}
function addGeometryServiceUrlsToProxy (configJson) {
  const urlsToProxy = []
  if (configJson?.appConfig?.geometryServiceUrl) {
    urlsToProxy.push(configJson.appConfig.geometryServiceUrl)
  }
  return urlsToProxy
}
function addAlternateFindTasksUrlsToProxy (configJson) {
  const urlsToProxy = []
  for (const serviceId in configJson.widgetConfig.search?.services) {
    if (configJson.widgetConfig.search.services[serviceId].alternateFindTaskUrl) {
      urlsToProxy.push(configJson.widgetConfig.search.services[serviceId].alternateFindTaskUrl)
    }
  }
  return urlsToProxy
}
